
import { Component, Vue } from 'vue-property-decorator';
import store from '@/store';
// Services
import UsuarioAppService from '@/services/usuario-app.service';
import SaldoDetalhadoService from '@/services/saldo-detalhado.service';
// Models
import { UsuarioFilter } from '@/shared/models/usuario/usuario.filter';
import { BaseDialogInterface } from '@/shared/models/base/dialog.interface';
import { UsuarioInterface } from '@/shared/models/usuario/usuario.interface';
import { LancarInterface } from '@/shared/models/usuario/lancar.interface';
// UTILS
import Rules from '@/shared/utils/rules.util';
import Masks from '@/shared/utils/masks.util';
import Format from '@/shared/utils/format.util';
import { GeneroInterface } from '@/shared/models/usuario/genero.interface';
import { LancamentoInterface } from '@/shared/models/usuario/lancamento.interface';
import { MapActionsSnackbarModule } from '@/store/snackbar/map-actions.snackbar';

import { SaldoDetalhadoInterface } from '@/shared/models/usuario/saldo-detalhado.interface';
import DatePicker from '../../components/base/DatePicker.vue';
import BaseCampos from '../../components/base/BaseCampos.vue';
import BaseLista from '../../components/base/BaseLista.vue';
import BasePesquisa from '../../components/base/BasePesquisa.vue';
import BasePagina from '../../components/base/BasePagina.vue';
import BaseDialog from '../../components/base/BaseDialog.vue';

@Component({
  components: {
    BasePagina,
    BaseDialog,
    BasePesquisa,
    BaseLista,
    BaseCampos,
    DatePicker,
  },
})
export default class UsuarioApp extends Vue {
  public totalDesserts = 2;

  public options = {};

  selected = [2];

  lancamentos: Array<LancamentoInterface> = [];

  saldoUsuarioSelecionado = '';

  cpfUsuarioSelecionado = '';

  public loadingPesquisa = false;

  public editedItem = {} as UsuarioInterface;

  public editedGenero = {} as GeneroInterface;

  public editedLancar = {} as LancarInterface;

  public saldoDetalhado = {} as SaldoDetalhadoInterface;

  public filtro = {} as UsuarioFilter;

  public dataNascimento: Record<string, any> = {
    date: '',
    time: '',
  };

  // Dialog
  public showExtrato = false;

  public showSaldoDetalhado = false;

  public showResetSenha = false;

  public showResetCreditos = false;

  public loadingResetCreditos = false;

  public showSincronizarCreditos = false;

  public loadingSincronizarCreditos = false;

  public showLancamentoManual = false;

  public dialogInterface = {
    formTitle: '',
    dialog: false,
    textBotaoPrimario: 'Salvar',
    funcaoPrimaria() {
      //
    },
    fecharModal: this.fecharModalEditar,
    colorBotaoPrimario: 'primary',
  } as BaseDialogInterface;

  public usuarios: Array<UsuarioInterface> = [];

  public headers: Array<Record<string, any>> = [
    {
      text: 'Nome',
      align: 'center',
      sortable: true,
      value: 'nome',
    },
    {
      text: 'Créditos',
      align: 'center',
      sortable: true,
      value: 'totalCreditos',
    },
    {
      text: 'Débitos',
      align: 'center',
      sortable: true,
      value: 'totalDebitos',
    },
    {
      text: 'Saldo',
      align: 'center',
      sortable: true,
      value: 'saldo',
    },
    {
      text: 'Ação',
      align: 'center',
      sortable: false,
      value: 'acao',
    },
  ];

  public listaValues = [
    {
      value: 'elegivel',
      function: this.traduzirElegivel,
      icon: true,
    },
  ];

  public colapses = [
    {
      titulo: 'Filtragem',
      nomeSlot: 'pesquisa',
    },
    {
      titulo: 'Lista de Usuários do Aplicativo',
      nomeSlot: 'lista',
    },
  ];

  public listaCamposPesquisa = [
    {
      text: 'Nome',
      type: 'textField',
      value: 'nome',
      cols: '3',
    },
    {
      text: 'CPF',
      type: 'textField',
      value: 'cpf',
      cols: '3',
      counter: '14',
      maxlength: '14',
    },
    {
      text: 'Celular',
      type: 'textField',
      value: 'celular',
      cols: '3',
      counter: '15',
      maxlength: '15',
    },
    {
      text: 'Email',
      type: 'textField',
      value: 'email',
      cols: '3',
    },
  ];

  public listaAcoes = [
    {
      tooltip: 'Editar Dados',
      icon: 'mdi-square-edit-outline',
      function: this.abrirEditar,
    },
    {
      tooltip: 'Extrato',
      icon: 'mdi-format-list-checks',
      function: this.abrirExtrato,
    },
    {
      tooltip: 'Saldo Detalhado',
      icon: 'mdi-clipboard-flow',
      function: this.abrirSaldoDetalhado,
    },
    {
      tooltip: 'Resetar Senha',
      icon: 'mdi-lock-reset',
      function: this.abrirResetSenha,
    },
    {
      tooltip: 'Resetar Créditos',
      icon: 'mdi-close-outline',
      function: this.abrirResetCreditos,
    },
    {
      tooltip: 'Sincronizar Créditos',
      icon: 'mdi-cloud-download',
      function: this.abrirSincronizarCreditos,
    },
    {
      tooltip: 'Lançamento Manual',
      icon: 'mdi-hand-pointing-right',
      function: this.abrirLancamentoManual,
    },

  ];

  private rules = Rules;

  private mask = Masks;

  public listaCamposEditar = [
    {
      text: 'CPF',
      type: 'textField',
      value: 'cpf',
      cols: '6',
      counter: '14',
      maxlength: '14',
      required: true,
      rules: [this.rules.campo_obrigatorio],
      disabled: true,
    },
    {
      text: 'Celular',
      mask: this.mask.celular,
      type: 'textField',
      value: 'celular',
      cols: '6',
      counter: '15',
      maxlength: '15',
      required: true,
      rules: [this.rules.campo_obrigatorio, this.rules.valida_somente_espacos],
    },
    {
      text: 'Nome',
      type: 'textField',
      value: 'nome',
      cols: '12',
      counter: '255',
      maxlength: '255',
      required: true,
      rules: [this.rules.campo_obrigatorio, this.rules.valida_somente_espacos],
    },
    {
      text: 'Email',
      type: 'textField',
      value: 'email',
      cols: '12',
      counter: '255',
      maxlength: '255',
      required: true,
      rules: [this.rules.campo_obrigatorio, this.rules.email],
    },
  ];

  private service = new UsuarioAppService();

  private saldoDetalhadoService = new SaldoDetalhadoService();

  async pesquisarNew(filtro: UsuarioFilter | undefined) {
    if (filtro.cpf || filtro.nome || filtro.celular || filtro.email) {
      this.loadingPesquisa = true;
      this.usuarios = await this.service.getExtratoSimplificadoComFiltros(filtro);
      this.loadingPesquisa = false;
    } else {
      store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, 'Nenhum filtro informado!');
      this.usuarios = [];
    }
  }

  async atualizar() {
    this.editedItem.dataNascimento = this.formataDataParaSalvar(this.dataNascimento);
    this.editedItem.genero = this.getGeneroSelecionado(this.editedGenero.id);
    this.service.atualizarDados(this.editedItem)
      .then(() => {
        this.fecharModalEditar();
        this.pesquisarNew(this.filtro);
      });
  }

  getGeneroSelecionado(genero: string) {
    return this.getAllGeneros()
      .filter((g) => g.id === genero)[0];
  }

  private traduzirElegivel(item: any) {
    return {
      icon: item.elegivel ? 'mdi-check' : 'mdi-close',
      color: item.elegivel ? 'green' : 'red',
      tooltip: item.elegivel ? 'Elegível' : 'Não Elegível',
    };
  }

  // Dialog de Editar
  private async abrirEditar(item: any) {
    this.dialogInterface.formTitle = 'Editar Usuário (APP)';
    this.dialogInterface.textBotaoPrimario = 'Salvar';
    this.dialogInterface.colorBotaoPrimario = 'primary';
    this.dialogInterface.funcaoPrimaria = this.atualizar;
    this.editedItem = await this.service.getDadosComCPF(item.cpf);
    this.editedGenero = this.editedItem.genero;
    this.editedItem.cpf = Format.cpf(this.editedItem.cpf);
    this.editedItem.celular = Format.celular(this.editedItem.celular);
    if (this.editedItem) {
      this.dataNascimento = this.formataDataParaVisualizar(this.editedItem.dataNascimento);
      this.dialogInterface.dialog = true;
    }
  }

  private async abrirExtrato(item: any) {
    this.lancamentos = await this.service.getExtratoCompletoComCPF(item.cpf);
    this.saldoUsuarioSelecionado = await this.service.getSaldoComCPF(item.cpf);
    this.showExtrato = true;
  }

  private async abrirSaldoDetalhado(item: any) {
    this.saldoDetalhado = await this.saldoDetalhadoService.getSaldoDetalhado(item.cpf);
    this.showSaldoDetalhado = true;
  }

  private abrirResetSenha(item: any) {
    this.cpfUsuarioSelecionado = item.cpf;
    this.showResetSenha = true;
  }

  private abrirResetCreditos(item: any) {
    this.cpfUsuarioSelecionado = item.cpf;
    this.showResetCreditos = true;
  }

  private abrirSincronizarCreditos(item: any) {
    this.cpfUsuarioSelecionado = item.cpf;
    this.showSincronizarCreditos = true;
  }

  private abrirLancamentoManual(item: any) {
    this.cpfUsuarioSelecionado = item.cpf;
    this.showLancamentoManual = true;
  }

  private async resetarSenhaAgora() {
    await this.service.resetarSenha(this.cpfUsuarioSelecionado);
    this.showResetSenha = false;
  }

  private async resetarCreditos() {
    this.loadingResetCreditos = true;
    await this.service.resetarCreditos(this.cpfUsuarioSelecionado);
    this.loadingResetCreditos = false;
    this.showResetCreditos = false;
    await this.pesquisarNew(this.filtro);
  }

  private async sincronizarCreditos() {
    this.loadingSincronizarCreditos = true;
    await this.service.sincronizarCreditos(this.cpfUsuarioSelecionado);
    this.loadingSincronizarCreditos = false;
    this.showSincronizarCreditos = false;
    await this.pesquisarNew(this.filtro);
  }

  private async lancarManual() {
    if ((this.$refs.formLancamento as HTMLFormElement).validate()) {
      this.editedLancar.cpf = this.cpfUsuarioSelecionado;
      await this.service.lancamentoManual(this.editedLancar);
      this.showLancamentoManual = false;
      this.editedLancar = {} as LancarInterface;
      await this.pesquisarNew(this.filtro);
    }
  }

  private fecharModalEditar() {
    this.dialogInterface.dialog = false;
    this.editedItem = {} as UsuarioInterface;
    this.editedGenero = {} as GeneroInterface;
  }

  private formataDataParaVisualizar(dateTime: string) {
    const [day, month, year] = dateTime.substring(0, 10)
      .split('-');
    return { date: `${day}-${month}-${year}` };
  }

  private formataDataParaSalvar(dateTime: Record<string, any>) {
    const [year, month, day] = (dateTime as any).date.split('-');
    return `${year}-${month}-${day}`;
  }

  private getAllGeneros() {
    return [
      {
        id: 'M',
        descricao: 'Masculino',
      },
      {
        id: 'F',
        descricao: 'Feminino',
      },
      {
        id: 'P',
        descricao: 'Personalizado',
      },
    ];
  }

  private getAllTiposLancamentos() {
    return [
      {
        id: 'CREDITO',
        descricao: 'Crédito',
      },
      {
        id: 'DEBITO',
        descricao: 'Débito',
      },
    ];
  }

  private retornaComAcenturacao(tipo: string) {
    return tipo === 'CREDITO' ? 'CRÉDITO' : 'DÉBITO';
  }

  private validaMaioridade() {
    if (this.dataNascimento && this.dataNascimento.date) {
      const now = new Date();
      const [year, month, day] = this.dataNascimento.date.substring(0, 10)
        .split('-');
      const dataUser = new Date(year, month - 1, day);
      const dezoitoAnos = new Date(now.getFullYear() - 18, now.getMonth(), now.getUTCDate());
      return dataUser <= dezoitoAnos ? true : 'Menor de 18';
    }
    return true;
  }
}
